import { render } from "./MainHeroSlider.vue?vue&type=template&id=1f30559e&scoped=true"
import script from "./MainHeroSlider.vue?vue&type=script&lang=js"
export * from "./MainHeroSlider.vue?vue&type=script&lang=js"

import "./MainHeroSlider.vue?vue&type=style&index=0&id=1f30559e&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f30559e"]])

export default __exports__